module.exports = __webpack_public_path__ + "img/evtv.4a0e8ee9.png";